<template lang="pug">
  .container
    el-row(:gutter="20" v-if="paineis && paineis.length > 0").new-project
      card(
        :isNewProject="true"
        @onClick="onClick"
      )
    listagem-paineis(
      v-if="paineis && paineis.length > 0"
      :paineis="paineis"
      @openModal="openModal"
      @delete="deletePainel"
    )
    validation-observer(ref='observer')
    modal-cadastro-painel(
      v-if="modal"
      :idPainel="idPainel"
      @closeModal="closeModal()"
      @refreshList="getMyPaineis()"
    )
    div(v-if="paineis && paineis.length == 0")
      validation-observer(ref='observer')
        modal-cadastro-painel(
          v-if="modal"
          @closeModal="closeModal()"
          @refreshList="getMyPaineis()"
        )
      bem-vindo(@openModal="openModal")
      </template>

<script>
import BemVindo from '@/screens/demandas/components/BemVindo'
import ModalCadastroPainel from '@/screens/demandas/components/ModalCadastroPainel'
import Card from '@/screens/demandas/components/Card'
import ListagemPaineis from '@/screens/demandas/components/ListagemPaineis'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {
  components: {
    BemVindo,
    ModalCadastroPainel,
    ListagemPaineis,
    Card
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      modal: false,
      paineis: null,
      idPainel: null
    }
  },

  methods: {
    ...mapActions({
      findPaineis: 'paineis/findByFilter',
      deletePainelAction: 'paineis/delete'
    }),

    onClick (event, id) {
      this.openModal()
    },

    async getMyPaineis () {
      const paineis = await this.findPaineis({
        isCompartilhado: false,
        ordem: 'dataCriacao',
        ordemDirecao: 'DESC'
      })
      this.paineis = paineis
    },

    closeModal () {
      this.modal = false

      this.getMyPaineis()
    },

    openModal (id) {
      this.idPainel = id
      this.modal = true
    },

    async deletePainel (id) {
      this.confirmBox('Deseja confirmar esta ação?', this.$messages.TITULO_WARNING,
        async () => {
          await this.deletePainelAction(id).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.PAINEL_EXCLUIDO_SUCESSO
            )
          })

          this.getMyPaineis()
        },
        () => { }, 'Sim', 'Não')
    }
  },

  mounted () {
    this.getMyPaineis()
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
}

.new-project {
  margin-bottom: 40px;
}

.title {
  text-align: center;
  font-size: 300px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/MeusPaineis.vue